import * as colors from '@giphy/colors'
import IconTooltip from 'shared/components/ui/icon-tooltip'
import styled from 'styled-components'

type Props = {
    text: string
    link?: string
}

const Container = styled.div`
    color: #4e4e4e;
    display: inline-block;
    float: right;
`

const ToolTip = styled.span`
    font-size: 12px;
    position: relative;
    right: 5px;

    .ss-help {
        padding: 0;
    }
    .ss-help + div {
        margin-bottom: 10px;
        right: -10px;
    }
`

const ToolTipInnerds = styled.div`
    font-weight: normal;
    text-align: center;
    line-height: normal;
    width: 200px;

    p:last-child {
        margin: 0px;
    }
`

const LearnMore = styled.div`
    text-align: center;

    a {
        color: ${colors.giphyIndigo};
        font-weight: bold;
    }
`

const SuperCutToolTip = ({ text, link }: Props) => (
    <Container>
        <ToolTip>
            <IconTooltip icon={'ss-help'} color={'#4e4e4e'}>
                <ToolTipInnerds>
                    <LearnMore>
                        <p style={{ textAlign: 'center' }}>{text}</p>
                        {link && (
                            <a href={link} target="_blank" rel="noreferrer">
                                Learn More
                            </a>
                        )}
                    </LearnMore>
                </ToolTipInnerds>
            </IconTooltip>
        </ToolTip>
    </Container>
)

export default SuperCutToolTip
